import { Action } from 'redux';
import { Team } from './types';
import { ErrorResponse, ListPayload } from 'core/http/response';
import { ArchiveFilterValue } from 'components/new-ui/composed/archive-filter/ArchiveFilter';

export enum TeamActions {
    LIST_TEAMS_REQUEST = 'LIST_TEAMS_REQUEST',
    LIST_TEAMS_SUCCESS = 'LIST_TEAMS_SUCCESS',
    LIST_TEAMS_ERROR = 'LIST_TEAMS_ERROR',
    GET_TEAM_BY_ID_REQUEST = 'GET_TEAM_BY_ID_REQUEST',
    GET_TEAM_BY_ID_SUCCESS = 'GET_TEAM_BY_ID_SUCCESS',
    GET_TEAM_BY_ID_ERROR = 'GET_TEAM_BY_ID_ERROR',
    ACTIVATE_TEAM_REQUEST = 'ACTIVATE_TEAM_REQUEST',
    ACTIVATE_TEAM_SUCCESS = 'ACTIVATE_TEAM_SUCCESS',
    ACTIVATE_TEAM_ERROR = 'ACTIVATE_TEAM_ERROR',
    DEACTIVATE_TEAM_REQUEST = 'DEACTIVATE_TEAM_REQUEST',
    DEACTIVATE_TEAM_SUCCESS = 'DEACTIVATE_TEAM_SUCCESS',
    DEACTIVATE_TEAM_ERROR = 'DEACTIVATE_TEAM_ERROR',
    ADD_TEAM_MEMBER_REQUEST = 'ADD_TEAM_MEMBER_REQUEST',
    ADD_TEAM_MEMBER_SUCCESS = 'ADD_TEAM_MEMBER_SUCCESS',
    ADD_TEAM_MEMBER_ERROR = 'ADD_TEAM_MEMBER_ERROR',
    REMOVE_TEAM_MEMBER_REQUEST = 'REMOVE_TEAM_MEMBER_REQUEST',
    REMOVE_TEAM_MEMBER_SUCCESS = 'REMOVE_TEAM_MEMBER_SUCCESS',
    REMOVE_TEAM_MEMBER_ERROR = 'REMOVE_TEAM_MEMBER_ERROR',
    UPDATE_TEAM_REQUEST = 'UPDATE_TEAM_REQUEST',
    UPDATE_TEAM_SUCCESS = 'UPDATE_TEAM_SUCCESS',
    UPDATE_TEAM_ERROR = 'UPDATE_TEAM_ERROR',
    SET_ARCHIVATION_STATUS_FILTER = 'SET_ARCHIVATION_STATUS_FILTER',
    GET_TEAM_INVOICES_COUNT_REQUEST = 'GET_TEAM_INVOICES_COUNT_REQUEST',
    GET_TEAM_INVOICES_COUNT_SUCCESS = 'GET_TEAM_INVOICES_COUNT_SUCCESS',
    GET_TEAM_INVOICES_COUNT_ERROR = 'GET_TEAM_INVOICES_COUNT_ERROR',
    GET_TEAM_MANIFESTS_COUNT_REQUEST = 'GET_TEAM_MANIFESTS_COUNT_REQUEST',
    GET_TEAM_MANIFESTS_COUNT_SUCCESS = 'GET_TEAM_MANIFESTS_COUNT_SUCCESS',
    GET_TEAM_MANIFESTS_COUNT_ERROR = 'GET_TEAM_MANIFESTS_COUNT_ERROR',
    GET_TEAM_JOBS_COUNT_REQUEST = 'GET_TEAM_JOBS_COUNT_REQUEST',
    GET_TEAM_JOBS_COUNT_SUCCESS = 'GET_TEAM_JOBS_COUNT_SUCCESS',
    GET_TEAM_JOBS_COUNT_ERROR = 'GET_TEAM_JOBS_COUNT_ERROR',
}

export interface LIST_TEAMS_REQUEST extends Action {
    type: TeamActions.LIST_TEAMS_REQUEST;
}
export interface LIST_TEAMS_SUCCESS extends Action {
    type: TeamActions.LIST_TEAMS_SUCCESS;
    payload: ListPayload<Team>;
}
export interface LIST_TEAMS_ERROR extends Action {
    type: TeamActions.LIST_TEAMS_ERROR;
    error: ErrorResponse;
}

export interface GET_TEAM_BY_ID_REQUEST extends Action {
    type: TeamActions.GET_TEAM_BY_ID_REQUEST;
}
export interface GET_TEAM_BY_ID_SUCCESS extends Action {
    type: TeamActions.GET_TEAM_BY_ID_SUCCESS;
    payload: Team;
}
export interface GET_TEAM_BY_ID_ERROR extends Action {
    type: TeamActions.GET_TEAM_BY_ID_ERROR;
    error: ErrorResponse;
}

export interface ACTIVATE_TEAM_REQUEST extends Action {
    type: TeamActions.ACTIVATE_TEAM_REQUEST;
}
export interface ACTIVATE_TEAM_SUCCESS extends Action {
    type: TeamActions.ACTIVATE_TEAM_SUCCESS;
    payload: Team;
}
export interface ACTIVATE_TEAM_ERROR extends Action {
    type: TeamActions.ACTIVATE_TEAM_ERROR;
    error: ErrorResponse;
}

export interface DEACTIVATE_TEAM_REQUEST extends Action {
    type: TeamActions.DEACTIVATE_TEAM_REQUEST;
}
export interface DEACTIVATE_TEAM_SUCCESS extends Action {
    type: TeamActions.DEACTIVATE_TEAM_SUCCESS;
    payload: Team;
}
export interface DEACTIVATE_TEAM_ERROR extends Action {
    type: TeamActions.DEACTIVATE_TEAM_ERROR;
    error: ErrorResponse;
}

export interface ADD_TEAM_MEMBER_REQUEST extends Action {
    type: TeamActions.ADD_TEAM_MEMBER_REQUEST;
}
export interface ADD_TEAM_MEMBER_SUCCESS extends Action {
    type: TeamActions.ADD_TEAM_MEMBER_SUCCESS;
    payload: Team;
}
export interface ADD_TEAM_MEMBER_ERROR extends Action {
    type: TeamActions.ADD_TEAM_MEMBER_ERROR;
    error: ErrorResponse;
}

export interface REMOVE_TEAM_MEMBER_REQUEST extends Action {
    type: TeamActions.REMOVE_TEAM_MEMBER_REQUEST;
}
export interface REMOVE_TEAM_MEMBER_SUCCESS extends Action {
    type: TeamActions.REMOVE_TEAM_MEMBER_SUCCESS;
    payload: Team;
}
export interface REMOVE_TEAM_MEMBER_ERROR extends Action {
    type: TeamActions.REMOVE_TEAM_MEMBER_ERROR;
    error: ErrorResponse;
}

export interface UPDATE_TEAM_REQUEST extends Action {
    type: TeamActions.UPDATE_TEAM_REQUEST;
}
export interface UPDATE_TEAM_SUCCESS extends Action {
    type: TeamActions.UPDATE_TEAM_SUCCESS;
    payload: Team;
}
export interface UPDATE_TEAM_ERROR extends Action {
    type: TeamActions.UPDATE_TEAM_ERROR;
    error: ErrorResponse;
}

export interface SET_ARCHIVATION_STATUS_FILTER extends Action {
    type: TeamActions.SET_ARCHIVATION_STATUS_FILTER;
    payload: ArchiveFilterValue;
}

export interface GET_TEAM_INVOICES_COUNT_REQUEST extends Action {
    type: TeamActions.GET_TEAM_INVOICES_COUNT_REQUEST;
}
export interface GET_TEAM_INVOICES_COUNT_SUCCESS extends Action {
    type: TeamActions.GET_TEAM_INVOICES_COUNT_SUCCESS;
    payload: { teamId: string; count: number };
}
export interface GET_TEAM_INVOICES_COUNT_ERROR extends Action {
    type: TeamActions.GET_TEAM_INVOICES_COUNT_ERROR;
    error: ErrorResponse;
}

export interface GET_TEAM_MANIFESTS_COUNT_REQUEST extends Action {
    type: TeamActions.GET_TEAM_MANIFESTS_COUNT_REQUEST;
}
export interface GET_TEAM_MANIFESTS_COUNT_SUCCESS extends Action {
    type: TeamActions.GET_TEAM_MANIFESTS_COUNT_SUCCESS;
    payload: { teamId: string; count: number };
}
export interface GET_TEAM_MANIFESTS_COUNT_ERROR extends Action {
    type: TeamActions.GET_TEAM_MANIFESTS_COUNT_ERROR;
    error: ErrorResponse;
}

export interface GET_TEAM_JOBS_COUNT_REQUEST extends Action {
    type: TeamActions.GET_TEAM_JOBS_COUNT_REQUEST;
}
export interface GET_TEAM_JOBS_COUNT_SUCCESS extends Action {
    type: TeamActions.GET_TEAM_JOBS_COUNT_SUCCESS;
    payload: { teamId: string; count: number };
}
export interface GET_TEAM_JOBS_COUNT_ERROR extends Action {
    type: TeamActions.GET_TEAM_JOBS_COUNT_ERROR;
    error: ErrorResponse;
}

export type TeamActionTypes =
    | LIST_TEAMS_REQUEST
    | LIST_TEAMS_SUCCESS
    | LIST_TEAMS_ERROR
    | GET_TEAM_BY_ID_REQUEST
    | GET_TEAM_BY_ID_SUCCESS
    | GET_TEAM_BY_ID_ERROR
    | DEACTIVATE_TEAM_REQUEST
    | DEACTIVATE_TEAM_SUCCESS
    | DEACTIVATE_TEAM_ERROR
    | ACTIVATE_TEAM_REQUEST
    | ACTIVATE_TEAM_SUCCESS
    | ACTIVATE_TEAM_ERROR
    | ADD_TEAM_MEMBER_REQUEST
    | ADD_TEAM_MEMBER_SUCCESS
    | ADD_TEAM_MEMBER_ERROR
    | REMOVE_TEAM_MEMBER_REQUEST
    | REMOVE_TEAM_MEMBER_SUCCESS
    | REMOVE_TEAM_MEMBER_ERROR
    | UPDATE_TEAM_REQUEST
    | UPDATE_TEAM_SUCCESS
    | UPDATE_TEAM_ERROR
    | SET_ARCHIVATION_STATUS_FILTER
    | GET_TEAM_INVOICES_COUNT_REQUEST
    | GET_TEAM_INVOICES_COUNT_SUCCESS
    | GET_TEAM_INVOICES_COUNT_ERROR
    | GET_TEAM_MANIFESTS_COUNT_REQUEST
    | GET_TEAM_MANIFESTS_COUNT_SUCCESS
    | GET_TEAM_MANIFESTS_COUNT_ERROR
    | GET_TEAM_JOBS_COUNT_REQUEST
    | GET_TEAM_JOBS_COUNT_SUCCESS
    | GET_TEAM_JOBS_COUNT_ERROR;
